// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"21f04564","479":"549b02d4","501":"5edc3044","602":"1a0cf6e2"}[chunkId] + ".chunk.js";
};